// extracted by mini-css-extract-plugin
export default {"root":"PaymentLinkDetails_root__VIvLo","header":"PaymentLinkDetails_header__GuHvL","codeDisplay":"PaymentLinkDetails_codeDisplay__Y6oB5"};